import { insertNotification, type NotificationRow } from '@/utils/notificationInsert';

export type VolunteerNotificationRow = NotificationRow;

/** @deprecated Use insertNotification */
export const insertVolunteerNotification = insertNotification;
